import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface AllNotificationsButtonProps {
  closeNotificationsPanel: () => void;
}

const AllNotificationsButton = ({ closeNotificationsPanel }: AllNotificationsButtonProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const openAllNotificationsModal = () => {
    const notificationsPath = `/dashboard/notifications/list`;
    navigate(notificationsPath);
    closeNotificationsPanel();
  };

  return (
    <div className="border-t border-slate-100 px-6 py-4">
      <Button type="primary" className="min-h-[42px] w-full" onClick={openAllNotificationsModal}>
        {t('notifications-all-button')}
      </Button>
    </div>
  );
};

export default AllNotificationsButton;
